import { useEffect, useRef } from 'react';
import { getFolder } from '@/redux/slices/fileManagerSlice';
import { selectAllFileSources, selectCurrentPath, selectFileSearchParams } from '@/redux/selectors/fileManagerSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

export const useFileManager = () => {
  const dispatch = useAppDispatch();
  const path = useAppSelector(selectCurrentPath);
  const sources = useAppSelector(selectAllFileSources);
  const hasLoadedInitially = useRef(false);
  const searchParams = useAppSelector(selectFileSearchParams);

  useEffect(() => {
    if (!hasLoadedInitially.current && sources.length) {
      hasLoadedInitially.current = true;
      dispatch(getFolder({ path: [sources[0].slug] }));
    }
  }, [sources, path, searchParams.prefix_search]);
};
